import { Decodable } from './_decodable';
class Product extends Decodable {
    id: number
    name: string
    createdAt: Date
    updatedAt: Date
    quantity?: number

    protected _map = {
        createdAt: e => this.parseDate(e),
        updatedAt: e => this.parseDate(e),
    }
}

export {
    Product
}